import React, { useEffect, useState } from "react";
import { Nav, NavItem, NavLink, Table } from "reactstrap";
import classnames from "classnames";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  Label,
} from "recharts";
import axios from "axios";
import ShiftCards from "./ShiftCards";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const DayReport = ({ machine, part, date, qualityTab, setQualityTab }) => {
  const [data, setData] = useState([]);
const exportToExcel = () => {
  if (!data.length) return;

  const exportData = data.map((row) => {
    const obj = {
      Date: date,
      Shift: row.shift,
      Part: row.part,
    };

    if (qualityTab !== "BAD") obj["Good Qty"] = row.good;
    if (qualityTab !== "GOOD") obj["Bad Qty"] = row.bad;
    if (qualityTab === "ALL") obj["Total"] = row.total;

    return obj;
  });

  const worksheet = XLSX.utils.json_to_sheet(exportData);
  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workbook, worksheet, "Day Report");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const file = new Blob([excelBuffer], {
    type:
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(file, `Day_Report_${date}.xlsx`);
};

  /* ---------------- TOOLTIP ---------------- */
  const CustomTooltip = ({ active, payload }) => {
    if (!active || !payload?.length) return null;

    const d = payload[0].payload;

    return (
      <div style={{ background: "#fff", border: "1px solid #ccc", padding: 10 }}>
        <strong>{d.shift}</strong>
        <div>Part: {d.part}</div>
        <div>Good: {d.good}</div>
        <div>Bad: {d.bad}</div>
        <div>Total: {d.total}</div>
      </div>
    );
  };
const [shiftData, setShiftData] = useState(null);
  /* ---------------- API + TRANSFORM ---------------- */
  useEffect(() => {
    if (!machine || !date) return;

    axios
      .get("https://api.hanoch.in/api/mcc-day-production/", {
        params: {
          machine_id: machine,
          partname: part || null,
          date,
        },
      })
      .then((res) => {
        const apiData = res.data || {};
         setShiftData(res.data);
        const rows = [];

        Object.entries(apiData).forEach(([shift, shiftData]) => {
          (shiftData.parts || []).forEach((p) => {
            rows.push({
              shift,
              part: p.part_number,
              label: `${shift} | ${p.part_number}`,
              good: p.good || 0,
              bad: p.bad || 0,
              total: p.total || 0,
            });
          });
        });

        setData(rows);
      })
      .catch((err) => console.error("Day production error:", err));
  }, [machine, part, date]);

  return (
    <>
    <ShiftCards shiftData={shiftData} />
      {/* ---------------- QUALITY TABS ---------------- */}
      <Nav pills className="justify-content-center mb-3">
        {["ALL", "GOOD", "BAD"].map((tab) => (
          <NavItem key={tab}>
            <NavLink
              className={classnames({ active: qualityTab === tab })}
              onClick={() => setQualityTab(tab)}
              style={{ cursor: "pointer" }}
            >
              {tab === "ALL"
                ? "All Products"
                : tab === "GOOD"
                ? "Good Products"
                : "Bad Products"}
            </NavLink>
          </NavItem>
        ))}
      </Nav>

      {/* ---------------- CHART ---------------- */}
      <div style={{ height: 360 }}>
        <ResponsiveContainer>
          <BarChart
            data={data}
            barSize={28}
            margin={{ left: 20, right: 20, bottom: 80 }}
          >
            <XAxis
              dataKey="label"
              angle={0}
              textAnchor="end"
              interval={0}
            />
            <YAxis>
              <Label value="Quantity" angle={-90} position="insideLeft" />
            </YAxis>

            <Tooltip content={<CustomTooltip />} />
            <Legend />

            {(qualityTab === "ALL" || qualityTab === "GOOD") && (
              <Bar dataKey="good" fill="#5ca56d" name="Good Products" />
            )}

            {(qualityTab === "ALL" || qualityTab === "BAD") && (
              <Bar dataKey="bad" fill="#90303a" name="Bad Products" />
            )}
          </BarChart>
        </ResponsiveContainer>
      </div>
<div className="d-flex justify-content-end mt-3">
  <button className="btn btn-success" onClick={exportToExcel}>
    Export to Excel
  </button>
</div>

      {/* ---------------- TABLE ---------------- */}
      <Table bordered responsive className="mt-4">
        <thead>
          <tr>
            <th>Shift ({date})</th>
            <th>Part</th>
            {qualityTab !== "BAD" && <th>Good Qty</th>}
            {qualityTab !== "GOOD" && <th>Bad Qty</th>}
            {qualityTab === "ALL" && <th>Total</th>}
          </tr>
        </thead>
        <tbody>
          {data.length === 0 && (
            <tr>
              <td colSpan="5" className="text-center">
                No data available
              </td>
            </tr>
          )}

          {data.map((row, idx) => (
            <tr key={idx}>
              <td>{row.shift}</td>
              <td>{row.part}</td>
              {qualityTab !== "BAD" && <td>{row.good}</td>}
              {qualityTab !== "GOOD" && <td>{row.bad}</td>}
              {qualityTab === "ALL" && <td>{row.total}</td>}
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  );
};

export default DayReport;
